import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getProducts(params = {}) {
        const query = new URLSearchParams(params).toString();
        return axios.get(`${API_URL}/pos/products?${query}`, { headers: authHeader() });
    },
    getClients() {
        return axios.get(`${API_URL}/pos/clients`, { headers: authHeader() });
    },
    createClient(data) {
        return axios.post(`${API_URL}/users`, data, { headers: authHeader() });
    },
    storeSale(data) {
        const headers = authHeader();
        if (data.evidence) {
            const formData = new FormData();
            Object.keys(data).forEach((key) => {
                if (key === 'evidence') {
                    formData.append('evidence', data.evidence);
                } else if (key === 'items') {
                    data.items.forEach((item, idx) => {
                        Object.keys(item).forEach((ik) => {
                            formData.append(`items[${idx}][${ik}]`, item[ik]);
                        });
                    });
                } else {
                    formData.append(key, data[key]);
                }
            });
            return axios.post(`${API_URL}/pos/sales`, formData, {
                headers: { ...headers, 'Content-Type': 'multipart/form-data' },
            });
        }
        return axios.post(`${API_URL}/pos/sales`, data, { headers });
    },
};
